export class DayDutyFilter {
    date: Date;
    activityIds: string[] = [];
    flightIds: string[] = [];
    errorTypes: number[] = [];
    flags: string[] = [];
    text: string;
}
